import { NextImageProps } from '~components/NextImage/NextImage.types';
import { PropsWithClassName } from '~types/Props.types';

export enum ServiceLabelMods {
  Dark = 'dark',
}

export type ServiceLabelProps = PropsWithClassName<{
  images: {
    white?: NextImageProps;
    black?: NextImageProps;
    blue?: NextImageProps;
  };
  title: string;
  href?: string;
  mods?: ServiceLabelMods[];
}>;
